import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { CartProvider } from "./context/CartContext";
import Notification from "./components/Notification";
//import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CartProvider>
        <Notification />
        <App />
      </CartProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Temporarily disabled to debug infinite refresh
// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.register('/service-worker.js').catch(err => {
//     console.log('Service Worker registration failed:', err);
//   });
// }
